<template>
  <div id="Turnover">
    <loading v-if="loadingRender"></loading>
    <panel
      v-if="wwwtblSarfaslTypeId == 1 && !$GetIsAnbohSaz() == false"
      Title="گردش تسهیلات"
      Des="از طریق این فرم می‌توانید گردش تسهیلات خود را در بازه زمانی دلخواه خود مشاهده کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <panel
      v-else-if="
        wwwtblSarfaslTypeId == 2 ||
        wwwtblSarfaslTypeId == 6 ||
        (wwwtblSarfaslTypeId == 13 && !$GetIsAnbohSaz() == false)
      "
      Title="گردش حساب‌ها"
      Des="از طریق این فرم می‌توانید گردش حساب‌های خود را در بازه زمانی دلخواه خود مشاهده کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <panel
      v-else
      Title="صورت حساب"
      Des="از طریق این فرم می‌توانید گردش حساب‌های خود را در بازه زمانی دلخواه خود مشاهده کنید"
      :IsBtnBack="true"
      ClassCustom="bg-dark-Custom text-right mt-2"
    ></panel>
    <div class="row">
      <div class="card p-3 m-3 w-100" id="Date">
        <div class="row">
          <div class="co-md-3 col-12">
            <i
              class="fa fa-reply Pointer border border-warning rounded-circle p-1"
              title="بازگشت صفحه قبل"
              @click="$router.go(-1)"
            ></i>
          </div>
        </div>
        <div class="row">
          <span class="alert alert-dark w-100 p-2 m-2 text-center"
            >لطفا بازه زمانی خود را انتخاب کرده و سپس گزینه
            <span class="text-success">جستجو</span> را بزنید
          </span>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-12 col-12 mt-2 text-right">
            <small>انتخاب حساب</small>
            <select
              v-if="IsLoad"
              name="cmbTaahodat"
              id="cmbTaahodat"
              class="form-control Pointer"
              v-model="Resultcmb"
            >
              <option v-if="this.IsLoad == false" value="-2">
                || در حال بارگذاری ، منتظر بمانید ... ||
              </option>
              <option selected value="-1">-- انتخاب حساب --</option>
              <option
                v-for="item in this.ListModel"
                :key="item.id"
                :value="item.id"
              >
                <span>{{ item.vcodeDesNo }} </span>
                <span>{{ item.nameFamily }} </span>
              </option>
            </select>
          </div>
          <div class="col-lg-4 col-md-6 col-12 mt-2 text-right netpa-turnover-date">
            <small>از تاریخ</small>
            <date-picker
              :editable="true"
              :auto-submit="true"
              :max="TarikhTa"
              color="rgb(94 163 30)"
              v-model="TarikhAz"
              :disabled="Dahgardesh"
            >
            </date-picker>
            <input
              type="text"
              tabindex="-1"
              class="d-none InputText"
              style="direction: ltr"
            />
          </div>
          <div class="col-lg-4 col-md-6 col-12 mt-2 text-right netpa-turnover-date">
            <small>تا تاریخ</small>
            <date-picker
              :editable="true"
              :auto-submit="true"
              :min="TarikhAz"
              color="rgb(94 163 30)"
              v-model="TarikhTa"
              :disabled="Dahgardesh"
            >
            </date-picker>
            <input
              type="text"
              tabindex="-1"
              class="d-none InputText"
              style="direction: ltr"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-2 netpa-turnover-toggles">
            <div class="row netpa-turnover-toggles__row">
              <div class="col-md-4 col-6 netpa-turnover-toggle">
                <div class="netpa-turnover-toggle__box">
                  <span class="netpa-turnover-toggle__text">ده گردش آخر</span>
                  <div class="custom-control custom-switch netpa-turnover-toggle__switch">
                    <input
                      type="checkbox"
                      class="custom-control-input InputText"
                      id="gardesh"
                      :checked="Dahgardesh"
                      @change="DahgardeshChange()"
                      :v-model="Dahgardesh"
                    />
                    <label class="custom-control-label" for="gardesh"
                      ><span class="sr-only">ده گردش آخر</span></label
                    >
                  </div>
                </div>
              </div>
              <div class="col-md-3 col-6 netpa-turnover-toggle">
                <div class="netpa-turnover-toggle__box">
                  <span class="netpa-turnover-toggle__text">تجمیع</span>
                  <div class="custom-control custom-switch netpa-turnover-toggle__switch">
                    <input
                      type="checkbox"
                      title="تجمیع صورت حساب"
                      class="custom-control-input InputText"
                      id="groupbyGardesh"
                      :checked="groupbyGardesh"
                      @change="groupbyGardeshChange()"
                      :v-model="groupbyGardesh"
                    />
                    <label class="custom-control-label" for="groupbyGardesh"
                      ><span class="sr-only">تجمیع</span></label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2 col-12 mt-3 d-none">
            <ExcelExport
              :data="exceltable"
              :title="titleExcel"
              :filename="'Turnover_' + $GetJalaliDateTime() + '.xls'"
              worksheet-name="Sheet1"
              @success="handleExcelSuccess"
              @error="handleExcelError"
            >
              <button class="btn btn-outline-success d-none">
                <i
                  class="fas fa-file-excel btn btn-outline-success Pointer d-none"
                  id="DownloadExcel"
                >
                  دانلود فایل اکسل
                </i>
              </button>
            </ExcelExport>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mt-3 netpa-turnover-search">
            <input
              type="button"
              name=""
              value="جستجو"
              class="btn btn-success netpa-turnover-search__btn"
              @click="
                GetGardesh();
                $ResetTimer();
              "
            />
          </div>
        </div>
      </div>
    </div>

    <vue-bootstrap4-table
      v-if="Istable"
      :rows="rows"
      :columns="columns"
      :config="config"
      :classes="classes"
      :actions="actions"
      @on-download="Download"
      @on-chart="DrawChart"
      @on-download-pdf="GetPDF"
    >
      <template slot="sort-asc-icon">
        <i class="fa fa-sort-up"></i>
      </template>
      <template slot="sort-desc-icon">
        <i class="fa fa-sort-down"></i>
      </template>
      <template slot="no-sort-icon">
        <i class="fa fa-sort"></i>
      </template>
      <template slot="empty-results">
        <p class="text-right">اطلاعاتی یافت نشد</p>
      </template>
      <template slot="sharh" slot-scope="props">
        <i
          class="fas fa-credit-card text-warning px-2"
          style="font-size: 16px"
          v-if="props.cell_value != ''"
        ></i>
        {{ props.cell_value }}
      </template>
      <template slot="reciept" slot-scope="props">
        <a @click="Recipt(props.row)" class="Pointer">
          <i class="fas fa-download text-secondary"></i
        ></a>
        {{ props.cell_value }}
      </template>
      <template slot="amaliyat" slot-scope="props">
        <div v-if="wwwtblSarfaslTypeId == 1">
          <small
            v-if="props.cell_value == 'دريافت تسهيلات'"
            class="text-danger"
          >
            <i class="fa fa-arrow-up"></i>
            {{ props.cell_value }}
          </small>
          <small v-else class="text-success">
            <i class="fa fa-arrow-down"></i>
            {{ props.cell_value }}
          </small>
        </div>
        <div v-else>
          <small v-if="props.cell_value == 'برداشت'" class="text-danger">
            <i class="fa fa-arrow-up"></i>
            {{ props.cell_value }}
          </small>
          <small v-else class="text-success">
            <i class="fa fa-arrow-down"></i>
            {{ props.cell_value }}
          </small>
        </div>
      </template>
      <template slot="Action" slot-scope="props">
        <button
          @click="RemoveBedeh(props.row)"
          v-if="
            props.row.bedeh.replace(/,/g, '').replace(/\./g, '') > 0 &&
            (props.row.bnpCashDBtblSanadRizId == 0 ||
              props.row.bnpCashDBtblSanadRizId == null)
          "
          class="btn btn-danger"
        >
          <i class="fas fa-trash ml-2"></i> حذف درخواست برداشت
        </button>
        <span v-else>تراکنش ثبت سند شده است</span>
      </template>
    </vue-bootstrap4-table>
    <div v-else dir="ltr">
      <button @click="DrawChart" class="btn btn-outline-success">
        <i class="fas fa-table"></i>
      </button>
      <apexchart
        type="area"
        height="350"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </div>
</template>
<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import Panel from "../Tools/NetPa/Panel.vue";
import loading from "../Tools/NetPa/Loading.vue";
import html2pdf from "html2pdf.js";
export default {
  data() {
    return {
      DataAxiosRow: {
        ArryfildValue: "",
        Method: "Post",
        Action: "Gardesh_Taahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_cmbTaahodat: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat",
        Token: this.$session.get("TokenNetPa"),
      },
      DataAxios_SahebHesab: {
        ArryfildValue: "",
        Method: "Post",
        Action: "ListTaahodat/TaahodatSahebHesab",
        Token: this.$session.get("TokenNetPa"),
      },
      ListModel: null,
      ListModelSahebHesab: null,
      IsLoad: false,
      TarikhAz: "",
      TarikhTa: "",
      exceltable: [],
      Resultcmb: null,
      Istable: true,
      rows: [],
      titleExcel: "",
      columns: [
        {
          label: "id",
          name: "id",
          visibility: false,
        },

        {
          label: "شرح سند",
          name: "sharh",
          column_classes: "sharhSand",
          row_classes: "sharhSand",
          visibility: this.$session.get("CustCode") == 868 ? false : true,
        },
        {
          label: "تاریخ تراکنش",
          name: "tarix",
          sort: true, // "false" by default
          initial_sort: true, // "false" by default
          initial_sort_order: "desc",
        },
        {
          label: "شماره سفارش",
          name: "orderId",
        },
        {
          label: "تراکنش",
          name: "amaliyat",
        },
        {
          label: "واریز",
          name: "bestan",
        },
        {
          label: "برداشت",
          name: "bedeh",
        },
        {
          label: "مانده",
          name: "mande",
        },
        {
          label: "رسید",
          name: "reciept",
        },
        // {
        //   label: 'عملیات',
        //   name: 'Action',
        // },
      ],
      actions: [
        {
          btn_text: "Pdf",
          event_name: "on-download-pdf",
          class: "btn btn-secondary rounded btnEXL ",
          event_payload: {
            msg: "my custom msg",
          },
        },
        {
          btn_text: "<i style='font-size:15px' class='fas fa-file-excel '>",
          event_name: "on-download",
          class: "btn  mx-2 btn-outline-success rounded btnEXL ",
          event_payload: {
            msg: "my custom msg",
          },
        },
        {
          btn_text: "<i style='font-size:15px' class='fas fa-chart-line '>",
          event_name: "on-chart",
          class: "btn  btn-outline-danger rounded",
          event_payload: {
            msg: "my custom msg",
          },
        },
      ],
      config: {
        pagination: false,
        pagination_info: false,
        per_page: 100,
        per_page_options: [10, 20, 30, 50, 100],
        show_refresh_button: false,
        show_reset_button: false,
        checkbox_rows: false,
        rows_selectable: true,
        card_title: "",
        card_mode: false,
        global_search: {
          placeholder: " جستجو",
          visibility: true,
          case_sensitive: false,
          showClearButton: true,
          searchOnPressEnter: false,
        },
      },
      classes: {
        table: "table-bordered table-striped table-sm ",
      },
      series: [
        {
          name: "",
          data: [],
        },
        {
          name: "",
          data: [],
        },
        {
          name: "",
          data: [],
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: "area",

          dataLabels: {
            enabled: true,
          },
          stroke: {
            curve: "smooth",
          },
          toolbar: {
            autoSelected: "zoom",
          },
        },
        dataLabels: {
          enabled: false,
        },

        title: {
          text: "",
          align: "",
        },
        colors: ["#2A3F54", "#435ebe", "#ff5000"],
        yaxis: {
          title: {
            text: "موجودی",
          },
        },
        xaxis: {
          type: "string",
          categories: [],
        },
        tooltip: {
          shared: false,
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          offsetX: 40,
        },

        markers: {
          size: 1,
        },
      },
      loadingRender: false,
      Dahgardesh: false,
      groupbyGardesh: false,
    };
  },
  mounted() {
    this.$AutoCloseMenuForMobile();

    const formData = new FormData();
    let info;
    formData.append(
      "wwwtblAzaId",
      this.$session.get("UserInfoNetPa").wwwtblAzaId,
    );
    formData.append(
      "wwwtblSarfaslTypeId",
      this.wwwtblSarfaslTypeId == undefined ? 2 : this.wwwtblSarfaslTypeId,
    );
    this.DataAxios_cmbTaahodat.ArryfildValue = formData;
    this.$PostFormData(this.DataAxios_cmbTaahodat)
      .then((data) => {
        this.IsLoad = true;
        this.ListModel = data;
        this.Resultcmb =
          this.TaahodatId == undefined ? data[0].id : this.TaahodatId;
      })
      .finally(() => {
        const formData = new FormData();
        formData.append(
          "wwwtblAzaId",
          this.$session.get("UserInfoNetPa").wwwtblAzaId,
        );
        formData.append(
          "wwwtblSarfaslTypeId",
          this.wwwtblSarfaslTypeId == undefined ? 2 : this.wwwtblSarfaslTypeId,
        );
        this.DataAxios_SahebHesab.ArryfildValue = formData;
        this.$PostFormData(this.DataAxios_SahebHesab).then((data) => {
          if (data.length > 0) {
            this.IsLoad = true;
            this.ListModelSahebHesab = data;
            for (
              let index = 0;
              index < this.ListModelSahebHesab.length;
              index++
            ) {
              info = this.ListModelSahebHesab[index];
              this.ListModel.push(info);
            }
          }
        });
      });
  },
  components: {
    VueBootstrap4Table,
    Panel,
    loading,
  },

  methods: {
    handleExcelSuccess(message) {
      this.$mySweetDefaultTost("موفق", message, "success", 2000);
    },
    handleExcelError(message) {
      this.$mySweetDefaultTost("خطا", message, "error", 2000);
    },
    RemoveBedeh(row) {
      this.$mySweetDefaultTost(
        "درحال بررسی",
        "درحال بررسی حذف درخواست برداشت از حساب ، لطفا منتظر بمانید",
        "info",
      );
      var DataAxios_Data = {
        ArryfildValue: "",
        Method: "Post",
        Action: "Gardesh_Taahodat/RemoveBardasht",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("wwwtblGardeshId", row.id);
      formData.append("Mablagh", row.bedeh.replace(/,/g, ""));
      formData.append("wwwtblEnteghal", row.wwwtblEnteghalId);
      DataAxios_Data.ArryfildValue = formData;

      this.$PostFormData(DataAxios_Data).then((data) => {
        if (data.status == "Ok") {
          this.$mySweetDefaultTost(
            "حذف موفق",
            " حذف درخواست برداشت از حساب مورد نظر با موفقیت انجام شد",
            "success",
            4000,
          );
          this.GetGardesh();
        }
      });
    },
    DahgardeshChange() {
      if (this.Dahgardesh) {
        this.Dahgardesh = false;
      } else {
        this.Dahgardesh = true;
        this.TarikhAz = "";
        this.TarikhTa = "";
        this.groupbyGardesh = false;
      }
    },
    groupbyGardeshChange() {
      if (this.groupbyGardesh) {
        this.groupbyGardesh = false;
      } else {
        this.groupbyGardesh = true;
        this.Dahgardesh = false;
      }
    },
    Recipt(data) {
      this.loadingRender = true;
      var DataAxios_Data = {
        ArryfildValue: "",
        Method: "Post",
        Action: "Gardesh_Taahodat/GardeshDetail",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("wwwtblEnteghalId", data.wwwtblEnteghalId);
      DataAxios_Data.ArryfildValue = formData;

      this.$PostFormData(DataAxios_Data)
        .then((res) => {
          this.loadingRender = false;
          if (res.status == true) {            
            if (res.data.length == 2) {
              var htmls = `
              <div class=" container-f textblack p-4" dir="rtl">
                <div class="containerbackground ">رسید عملیات مالی </div>
                <div class="row">
                  <div class="col-3"></div>
                  <div class="col-6 text-center">
                    <h4>رسید تراکنش </h4>
                    <h6>${this.$session.get("NameSandogh")}</h6>
                  </div>
                  <div class="col-3 text-center" >
                  </div>
                </div>
                <div class="row textblack">
                  <div class="col-6 text-right">
                    <p>تاریخ صدور:${this.$GetJalaliDate()}</p>
                 </div>
                  <div class="col-6 text-left">
                   <p> کد پیگیری : ${res.data[0].coderahgiri} </p>
                  </div>
                </div>
              </div>
              <div class="row textblack border p-3 mt-2 mx-4">
                <div class="container">
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">نوع عملیات:</div>
                    <div class="col-6 text-right text-info">
                      ${
                        res.data[0].wwwTaahodatId > 0 &&
                        res.data[1].wwwTaahodatId > 0
                          ? "انتقال وجه داخلی"
                          : "انتقال وجه"
                      }
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مشخصات حساب مبدا</div>
                    <div class="col-6 ">
                      ${
                        res.data[0].fullname
                      }  <span dir="ltr" class="float-right"> ${
                res.data[0].vCode
              }</span>
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مشخصات حساب مقصد</div>
                    <div class="col-6">
                       ${
                         res.data[1].fullname
                       }  <span dir="ltr" class="float-right"> ${
                res.data[1].vCode
              }</span>
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مبلغ:</div>
                    <div class="col-6 text-right">
                      ${data["mablagh"]}  ${this.$GetVahedPool()}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">تاریخ تراکنش:</div>
                    <div class="col-6 text-right">
                      ${data["tarix"]}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right"> شماره سفارش:</div>
                    <div class="col-6 text-right">
                      ${data["orderId"]}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">ساعت تراکنش:</div>
                    <div class="col-6 text-right">
                      ${res.data[0].zamanInsert}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">شرح وضعیت:</div>
                    <div class="col-6 text-right">
                      ${data["sharh"]}

                    </div>
                  </div>
                </div>
              </div>
                  <div class="row">
                  <div class="col-12 text-center textblack">
                      <hr>
                      <span style="font-size: x-small;">
                          طراحی و پیاده سازی شرکت پاسارگاد
                      </span>
                      </br>
                      <img style="height:10% !important" src="/img/icons/apple-touch-icon-180x180.png">
                      </br>
                      <span style="font-size: x-small;">
                          www.bnpco.ir
                      </span>

              </div>
              </div>`;
            }
            if (res.data.length == 1) {
              var htmls = `
              <div class=" container-f textblack p-4" dir="rtl">
                <div class="containerbackground ">رسید عملیات مالی </div>
                <div class="row">
                  <div class="col-3"></div>
                  <div class="col-6 text-center">
                    <h4>رسید تراکنش </h4>
                    <h6>${this.$session.get("NameSandogh")}</h6>
                  </div>
                  <div class="col-3 text-center" >
                  </div>
                </div>
                <div class="row textblack mt-2">
                  <div class="col-6 text-right">
                    <p>تاریخ صدور:${this.$GetJalaliDate()}</p>
                 </div>
                  <div class="col-6 text-left">
                   <p> کد پیگیری : ${res.data[0].coderahgiri} </p>
                  </div>
                </div>
              </div>
              <div class="row textblack border p-3 mx-4">
                <div class="container">
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">نوع عملیات:</div>
                    <div class="col-6 text-right ${
                      data.amaliyat == "برداشت" ? "text-danger" : "text-success"
                    }">
                      ${data.amaliyat}
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مشخصات حساب مبدا</div>
                    <div class="col-6 ">
                      ${
                        data.amaliyat == "برداشت" ? res.data[0].fullname : ""
                      }  <span dir="ltr" class="float-right"> ${
                data.amaliyat == "برداشت" ? res.data[0].vCode : "-"
              }</span>
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مشخصات حساب مقصد</div>
                    <div class="col-6">
                         <span dir="ltr" class="float-right"> ${
                           data.amaliyat == "برداشت"
                             ? res.data[0].cardNo == null
                               ? res.data[0].shebaNo +
                                 " : شبا " +
                                 " " +
                                 res.data[0].sahebHesab
                               : res.data[0].cardNo.match(/.{1,4}/g).join("-") +
                                 " : کارت " +
                                 " " +
                                 res.data[0].sahebHesab
                             : res.data[0].vCode + " - " + res.data[0].fullname
                         }</span>
                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">مبلغ:</div>
                    <div class="col-6 text-right">
                      ${data["mablagh"]}  ${this.$GetVahedPool()}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">تاریخ تراکنش:</div>
                    <div class="col-6 text-right">
                      ${data["tarix"]}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">ساعت تراکنش:</div>
                    <div class="col-6 text-right">
                      ${res.data[0].zamanInsert}

                    </div>
                  </div>
                  <div class="row border-bottom mb-1 p-2">
                    <div class="col-6 text-right">شرح وضعیت:</div>
                    <div class="col-6 text-right">
                      ${data["sharh"]}

                    </div>
                  </div>
                </div>
              </div>
                  <div class="row">
                  <div class="col-12 text-center textblack">
                      <hr>
                      <span style="font-size: x-small;">
                          طراحی و پیاده سازی شرکت پاسارگاد
                      </span>
                      </br>
                      <img style="height:10% !important" src="/img/icons/apple-touch-icon-180x180.png">
                      </br>
                      <span style="font-size: x-small;">
                          www.bnpco.ir
                      </span>

              </div>
              </div>`;
            }
            var htmlObject = document.createElement("div");
            htmlObject.innerHTML = htmls;
            html2pdf(htmlObject, {
              jsPDF: { format: "a5" },
            });
          } else {
            //this.$mySweetDefaultTost('خطا', res.message, 'warning', 4000)

            var htmls = `
    <div class=" container-f textblack p-4" dir="rtl">
      <div class="containerbackground ">رسید عملیات مالی </div>
      <div class="row">
        <div class="col-3"></div>
        <div class="col-6 text-center">
          <h4>رسید تراکنش </h4>
          <h6>${this.$session.get("NameSandogh")}</h6>
        </div>
        <div class="col-3 text-center" >
        </div>
      </div>
      <div class="row textblack">
        <div class="col-12 text-right">
          <p>تاریخ صدور:${this.$GetJalaliDate()}</p>

        </div>

      </div>
    </div>
    <div class="row textblack border p-3 mt-2 mx-4">
      <div class="container">
        <div class="row border-bottom mb-1 p-2">
          <div class="col-6 text-right">نوع عملیات:</div>
          <div class="col-6 text-right">
             ${data["amaliyat"]}
          </div>
        </div>
        <div class="row border-bottom mb-1 p-2">
          <div class="col-6 text-right">مشخصات حساب</div>
          <div class="col-6 text-right">
             ${data["desNoe"]} -- <span dir="ltr"> ${data["vCode"]}</span>

          </div>
        </div>
        <div class="row border-bottom mb-1 p-2">
          <div class="col-6 text-right">مبلغ:</div>
          <div class="col-6 text-right">
             ${data["mablagh"]}  ${this.$GetVahedPool()}

          </div>
        </div>
        <div class="row border-bottom mb-1 p-2">
          <div class="col-6 text-right">تاریخ تراکنش:</div>
          <div class="col-6 text-right">
             ${data["tarix"]}

          </div>
        </div>
        <div class="row border-bottom mb-1 p-2">
          <div class="col-6 text-right">شرح وضعیت:</div>
          <div class="col-6 text-right">
             ${data["sharh"]}

          </div>
        </div>
      </div>
    </div>
        <div class="row">
        <div class="col-12 text-center textblack">
            <hr>
            <span style="font-size: x-small;">
                طراحی و پیاده سازی شرکت پاسارگاد
            </span>
            </br>
            <img style="height:10% !important" src="/img/icons/apple-touch-icon-180x180.png">
            </br>
            <span style="font-size: x-small;">
                www.bnpco.ir
            </span>

    </div>
    </div>`;

            var htmlObject = document.createElement("div");
            htmlObject.innerHTML = htmls;
            html2pdf(htmlObject, {
              jsPDF: { format: "a5" },
            });
          }
        })
        .catch(function (err) {
          console.error(err);
        });

      // <img style="max-width:100% !important" src="${this.$cookies.get('URL') + 'PDF/logo.png'}" alt="${this.$session.get('NameSandogh')}">
    },
    Download() {
      document.getElementById("DownloadExcel").click();
    },
    exelReport(rows) {
      ///console.log('Reeeeeeeeport', rows);
      this.exceltable = [];
      const accountNumber = " " + rows[0].vCode;
      this.titleExcel =
        "گردش حساب مربوط به حساب " +
        rows[0].desNoe +
        " " +
        accountNumber +
        " از تاریخ : " +
        this.TarikhAz +
        " تا تاریخ : " +
        this.TarikhTa;

      rows.forEach((element) => {
        var excelrow = {
          "شماره حساب": element.vCode,
          "شرح سند": element.sharh,
          تراکنش: element.amaliyat,
          واریز: element.bestan,
          برداشت: element.bedeh,
          موجودی: element.mande,
          تاریخ: element.tarix,
         ' شماره سفارش' : element.orderId
        };

        this.exceltable.push(excelrow);
      });
      // console.log( this.exceltable);
    },
    parseMablaghNumber(value) {
      return typeof value === "number"
        ? value
        : parseInt(String(value).replace(/,/g, "")) || 0;
    },
    groupByTarixWithFixedSharh(data) {
      data.sort((a, b) => a.zamanInsert.localeCompare(b.zamanInsert));

      const counts = data.reduce((acc, item) => {
        acc[item.tarix] = (acc[item.tarix] || 0) + 1;
        return acc;
      }, {});

      const grouped = {};
      const result = [];

      for (const item of data) {
        const date = item.tarix;

        if (counts[date] > 1) {
          if (!grouped[date]) {
            grouped[date] = {
              id: item.id,
              wwwtblAzaId: item.wwwtblAzaId,
              vCode: item.vCode,
              tarix: date,
              sharh: "صورت حساب تجمیع شده",
              amaliyat: item.amaliyat,
              amaliyatInt: item.amaliyatInt,
              desNoe: item.desNoe,
              desTaahod: item.desTaahod,
              bedeh: 0,
              bestan: 0,
              mandeAzGhabl: item.mandeAzGhabl,
              shomareSanad: item.shomareSanad,
              zamanInsert: item.zamanInsert,
              bnpCashDBtblSanadRizId: item.bnpCashDBtblSanadRizId,
              wwwtblEnteghalId: item.wwwtblEnteghalId,
              isMovaghat: item.isMovaghat,
              mablagh: item.mablagh,
              mande: 0,
              terminalId: item.terminalId,
              orderId :item.orderId
            };
          }

          const bedeh = item.bedeh;
          const bestan = item.bestan;

          grouped[date].bedeh += bedeh;
          grouped[date].bestan += bestan;

          grouped[date].mande = this.parseMablaghNumber(item.mande);
        } else {
          result.push({
            id: item.id,
            wwwtblAzaId: item.wwwtblAzaId,
            vCode: item.vCode,
            tarix: date,
            sharh: item.sharh,
            amaliyat: item.amaliyat,
            amaliyatInt: item.amaliyatInt,
            desNoe: item.desNoe,
            desTaahod: item.desTaahod,
            bedeh: item.bedeh,
            bestan: item.bestan,
            mandeAzGhabl: item.mandeAzGhabl,
            shomareSanad: item.shomareSanad,
            zamanInsert: item.zamanInsert,
            bnpCashDBtblSanadRizId: item.bnpCashDBtblSanadRizId,
            wwwtblEnteghalId: item.wwwtblEnteghalId,
            isMovaghat: item.isMovaghat,
            mablagh: item.mablagh,
            mande: this.parseMablaghNumber(item.mande),
            terminalId: item.terminalId,
            orderId : item.orderId
          });
        }
      }

      const finalResult = [...result, ...Object.values(grouped)];
      finalResult.sort((a, b) => b.tarix.localeCompare(a.tarix));

      return finalResult;
    },
    applyGardeshData(data) {
      if (!data.length) {
        this.$mySweetDefaultTost(
          "عدم وجود اطلاعات",
          "تراکنشی یافت نشد ، فیلتر جستجوی خود را تغییر دهید",
          "warning",
          2000,
        );
        this.config.pagination = false;
        this.rows = [];
        return;
      }

      if (this.groupbyGardesh) {
        data = this.groupByTarixWithFixedSharh(data);
      }

      let info;
      let list = [];
      if (this.Dahgardesh == true && data.length > 10) {
        for (let index = 0; index < 10; index++) {
          info = data[index];
          list.push(info);
        }
      } else {
        this.config.pagination = data.length > 10;
        for (let index = 0; index < data.length; index++) {
          info = data[index];
          list.push(info);
        }
      }

      this.rows = this.$FormatMablaghGrid(list);
      this.exelReport(this.rows);

      this.series = [
        { name: "", data: [] },
        { name: "", data: [] },
        { name: "", data: [] },
      ];
      this.chartOptions.xaxis.categories = [];

      for (let index = list.length - 1; index >= 0; index--) {
        const element = data[index];
        const mandeVal =
          typeof element.mande === "number"
            ? element.mande
            : Number(String(element.mande).replace(/,/g, ""));
        const bestanVal =
          typeof element.bestan === "number"
            ? element.bestan
            : Number(String(element.bestan).replace(/,/g, ""));
        const bedehVal =
          typeof element.bedeh === "number"
            ? element.bedeh
            : Number(String(element.bedeh).replace(/,/g, ""));

        this.chartOptions.xaxis.categories.push(element.tarix);
        this.series[0].name = "مانده";
        this.series[0].data.push(mandeVal);
        this.series[1].name = "واریز";
        this.series[1].data.push(bestanVal);
        this.series[2].name = "برداشت";
        this.series[2].data.push(bedehVal);
      }
    },
    GetGardesh() {
      if (this.Resultcmb == null || this.Resultcmb == -1) {
        this.$mySweetDefaultTost(
          "خطا",
          "لطفا یک حساب انتخاب کنید",
          "warning",
          2000,
        );
        this.rows = [];
        return;
      }

      this.loadingRender = true;
      const formData = new FormData();
      formData.append("wwwtblTaahodatId", this.Resultcmb);
      formData.append("AzTarix", this.TarikhAz == null ? "" : this.TarikhAz);
      formData.append("TaTarix", this.TarikhTa == null ? "" : this.TarikhTa);
      formData.append("TerminalIdInput", "");
      this.DataAxiosRow.ArryfildValue = formData;

      this.$PostFormData(this.DataAxiosRow)
        .then((data) => {
          this.applyGardeshData(data);
        })
        .finally(() => {
          this.loadingRender = false;
        });
    },
    DrawChart() {
      this.Istable = !this.Istable;
    },
    GetPDF() {
      if (this.rows.length > 0) {
        this.$router.push({
          name: "TurnoverPDF",
          params: { Rows: this.rows, Taahod: find },
        });
      }
    },
  },
  props: [
    "TaahodatId",
    "wwwtblSarfaslTypeId",
    "wwwtblAzaId",
    "wwwtblAzaIdAccount",
  ],
  created() {
    if (this.wwwtblAzaId) {
      this.$session.set("UserFromLoan", [this.wwwtblAzaId, false]);
    }
    if (this.wwwtblAzaIdAccount) {
      this.$session.set("UserFromAccount", [this.wwwtblAzaIdAccount, false]);
    }
  },
};
</script>
<style>
.sharhSand {
  text-align: right !important;
}

.btn-group {
  float: left !important;
}
.container-f {
  position: relative !important;
}

.containerbackground {
  margin: 3rem;
  position: absolute;
  top: 200px;
  left: 100px;
  z-index: -1;
  transform: rotate(-20deg);
  -webkit-transform: rotate(-20deg);
  color: #abe4f871;
  font-size: 40px;
}
.textblack {
  color: rgb(70, 70, 70) !important;
  border-color: rgb(70, 70, 70) !important;
  border-radius: 10px !important;
  padding: 2% !important;
}

.netpa-turnover-date {
  min-width: 0;
}

.netpa-turnover-date small {
  display: block;
  margin-bottom: 0.25rem;
}

.netpa-turnover-date .vpd-input-group,
.netpa-turnover-date .vpd-input-group input,
.netpa-turnover-date .form-control {
  width: 100% !important;
  max-width: 100%;
  box-sizing: border-box;
}

.netpa-turnover-toggles__row {
  margin-left: 0;
  margin-right: 0;
}

.netpa-turnover-toggle {
  min-width: 0;
  padding-left: 4px;
  padding-right: 4px;
}

.netpa-turnover-toggle__box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  width: 100%;
  min-height: calc(1.5em + 0.75rem + 2px);
  height: auto;
  padding: 0.45rem 0.65rem;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  background: #fff;
  box-sizing: border-box;
  overflow: hidden;
}

.netpa-turnover-toggle__text {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 11px;
  line-height: 1.35;
  white-space: nowrap;
  text-align: right;
}

.netpa-turnover-toggle__switch {
  flex: 0 0 2.25rem;
  width: 2.25rem;
  min-height: 1.5rem;
  padding: 0 !important;
  margin: 0;
}

.netpa-turnover-toggle__switch .custom-control-label {
  width: 2.25rem;
  height: 1.5rem;
  margin: 0;
  padding: 0;
  font-size: 0;
  line-height: 0;
}

.netpa-turnover-toggle__switch .custom-control-label::before {
  left: 0 !important;
  right: auto !important;
  top: 0.125rem;
}

.netpa-turnover-toggle__switch .custom-control-label::after {
  left: 2px !important;
  right: auto !important;
  top: calc(0.125rem + 2px);
}

@media (min-width: 768px) {
  .netpa-turnover-toggle__text {
    font-size: 12px;
  }
}

.netpa-turnover-search {
  display: flex;
  justify-content: stretch;
}

.netpa-turnover-search__btn {
  width: 100%;
  min-width: 10rem;
  min-height: 42px;
  margin-top: 0.25rem;
  padding: 0.5rem 1.5rem;
  white-space: nowrap;
  overflow: visible;
  text-overflow: clip;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.25;
  box-sizing: border-box;
}

@media (min-width: 768px) {
  .netpa-turnover-search {
    justify-content: flex-end;
  }

  .netpa-turnover-search__btn {
    width: auto;
    min-width: 11rem;
  }
}
</style>
